import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { ref } from '@dbk-legacy/muster/utils';

import styles from './portfolio-switch.styles';

const PAGE_SIZE = 5;

class PortfolioSwitch extends PureComponent {
  constructor(props) {
    super();
    this.renderPortfolio = this.renderPortfolio.bind(this);

    this.state = {
      pageIndex: this.getPageIndex(props.selectedPortfolioId, props.portfolios),
    };
  }

  getPortfolioIndex(selectedPortfolioId, portfolios) {
    return portfolios.findIndex((portfolio) => portfolio.id === selectedPortfolioId);
  }

  getPageIndex(selectedPortfolioId, portfolios) {
    const portfolioIndex = this.getPortfolioIndex(selectedPortfolioId, portfolios);
    return Math.floor(portfolioIndex / PAGE_SIZE);
  }

  renderDots(direction) {
    const pageIndex = this.state.pageIndex + direction;

    return (
      <TouchableOpacity
        testID={(direction > 0) ? 'next-page' : 'prev-page'}
        onPress={() => this.setState({ pageIndex })}
      >
        <View style={styles.circleWrapper}>
          <View style={styles.circle} />
          <View style={styles.circle} />
          <View style={styles.circle} />
        </View>
      </TouchableOpacity>
    );
  }

  renderPortfolio(portfolio) {
    const {
      onPortfolioPress,
      selectedPortfolioId,
    } = this.props;

    const portfolioId = portfolio.id;
    const isSelectedPortfolio = portfolioId === selectedPortfolioId;

    return (
      <TouchableOpacity
        testID="portfolio"
        key={portfolioId}
        style={styles.button}
        onPress={() => onPortfolioPress(portfolioId)}
      >
        <View
          style={[
            styles.option,
            (isSelectedPortfolio) ? styles.selectedOption : null,
          ]}
        />
      </TouchableOpacity>
    );
  }

  render() {
    const { portfolios } = this.props;

    if (portfolios.length < 2) {
      return (
        <View style={styles.blank} />
      );
    }

    const pageIndex = this.state.pageIndex;
    const numberOfPages = Math.ceil(portfolios.length / PAGE_SIZE);

    const filteredPortfolios =
      portfolios.filter((portfolio, i) =>
      i >= pageIndex * PAGE_SIZE && i < pageIndex * PAGE_SIZE + PAGE_SIZE);

    return (
      <View style={styles.container}>
        {pageIndex > 0 && this.renderDots(-1)}
        {filteredPortfolios.map(this.renderPortfolio)}
        {pageIndex < numberOfPages - 1 && this.renderDots(1)}
      </View>
    );
  }
}

PortfolioSwitch.propTypes = {
  portfolios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })).isRequired,
  selectedPortfolioId: PropTypes.string.isRequired,
  onPortfolioPress: PropTypes.func,
};

export default createContainer({
  $fragments: {
    portfolios: {
      $type: 'list',
      $range: {
        offset: 0,
        length: ref('app.user.portfolios.length'),
      },
      $node: {
        id: true,
      },
    },
  },
})(PortfolioSwitch);

export { PortfolioSwitch };
